export const GET_SINGLE_COMPANY = 'GET_SINGLE_COMPANY';
export const CLEAR_COMPANY = 'CLEAR_COMPANY';
export const SUCCESSFULL_ACTION_DELETE_COMPANY = 'SUCCESSFULL_ACTION_DELETE_COMPANY';
export const FAILED_ACTION_DELETE_COMPANY = 'FAILED_ACTION_DELETE_COMPANY';
export const SUCCESSFULL_ACTION_CREATE_COMPANY = 'SUCCESSFULL_ACTION_CREATE_COMPANY';
export const FAILED_ACTION_CREATE_COMPANY = 'FAILED_ACTION_CREATE_COMPANY';
